import React from 'react'
import { Tabs } from 'antd'
import { useTranslation } from 'next-i18next'
import { PosibleLocale } from 'src/core/models'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomEditorInput, CustomText } from 'src/components'
import { getDescriptionLanguages, isHtmlTextEmpty } from 'src/core/helpers'
import {
  isProjectDescriptionErrorVisible,
  projectFormIsActiveSelector,
  setProjectFormItemValue
} from 'src/features'

const ProjectFormDescriptions: React.FC = () => {
  const dispatch = useAppDispatch()
  const { t, i18n: { language } } = useTranslation()
  const isErrorVisible = useAppSelector(isProjectDescriptionErrorVisible)
  const isActive = useAppSelector(projectFormIsActiveSelector)
  const languages = getDescriptionLanguages(t)

  const handleChange = (text: string, locale: PosibleLocale) => {
    const value = isHtmlTextEmpty(text) ? null : text
    dispatch(setProjectFormItemValue({ key: `description_${locale}`, value }))
  }

  return <>
    <Tabs defaultActiveKey={language} size={'small'}>
      {languages.map((item) => <Tabs.TabPane tab={item.label} key={item.locale}>
        <CustomEditorInput
          name={`description_${item.locale}`}
          placeholder={t('Projects.Form.TextLabel')}
          required={item.locale === 'en' && isActive}
          onChange={(value: string) => handleChange(value, item.locale)}
        />
      </Tabs.TabPane>)}
    </Tabs>

    {isErrorVisible && <CustomText
      label={t('Projects.Form.DescriptionInfo', { language: 'en' })}
      type='secondary'
    />}
  </>
}

export default ProjectFormDescriptions
